<template>
<el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu :default-active="$route.path" :collapse="isCollapse" :background-color="variables.menuBg" :text-color="variables.menuText" :active-text-color="variables.menuActiveText" mode="vertical">
        <el-menu-item @click="changeDrawer()">
            <svg-icon icon-class="component" />系统切换
        </el-menu-item>
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
</el-scrollbar>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
export default {
  components: {
    SidebarItem
  },
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    ...mapGetters(['permission_routers', 'sidebar']),
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    // 改变抽屉状态
    changeDrawer() {
      this.drawer = !this.drawer
      this.$emit('getDrawer', this.drawer)
    }
  }
}
</script>
